var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendEmailConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1H5C2.79086 1 1 2.79086 1 5V21C1 23.2091 2.79086 25 5 25H21C23.2091 25 25 23.2091 25 21V5C25 2.79086 23.2091 1 21 1Z",
    fill: "#004BA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 20.3333L16.7334 19.4L17.7834 18.3333H15V17H17.7834L16.7167 15.9333L17.6667 15L20.3334 17.6667L17.6667 20.3333ZM7.66671 18.3333C7.30004 18.3333 6.98615 18.2028 6.72504 17.9417C6.46393 17.6805 6.33337 17.3667 6.33337 17V8.99999C6.33337 8.63332 6.46393 8.31943 6.72504 8.05832C6.98615 7.79721 7.30004 7.66666 7.66671 7.66666H18.3334C18.7 7.66666 19.0139 7.79721 19.275 8.05832C19.5362 8.31943 19.6667 8.63332 19.6667 8.99999V14.2C19.3667 14.0222 19.0473 13.8889 18.7084 13.8C18.3695 13.7111 18.0223 13.6667 17.6667 13.6667C16.5556 13.6667 15.6112 14.0555 14.8334 14.8333C14.0556 15.6111 13.6667 16.5555 13.6667 17.6667V18.3333H7.66671ZM13 13.6667L18.3334 10.3333V8.99999L13 12.3333L7.66671 8.99999V10.3333L13 13.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendEmailConfirmation);
export default __webpack_public_path__ + "static/media/resendEmailConfirmation.ce34b893f34662ba3b5d0876ce986286.svg";
export { ForwardRef as ReactComponent };